let splideProductHighlights = new Splide( '.splide-product-highlights', {
    perPage: 2.9,
    arrows: false,
    pagination: true,
    gap: 24,
    focus: 'left',
  breakpoints: {
    1600: {
          perPage: 1.9,
         perMove: 1,
      pagination: true,
           gap: 24,
       },
        990: {
          perPage: 1.2,
         perMove: 1,
          pagination: false,
           gap: 16,
        }
      } 
} );

splideProductHighlights.mount();